import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import Spinner from "react-bootstrap/Spinner";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ThinFooter from "../Footer/ThinFooter";
import axiosInstance from "../../axiosInstance";

const DEFAULT_COORDINATES = { lat: 37.7749, lon: -122.4194 }; // Default coordinates (San Francisco)

const SingleGeoFences = () => {
  const { id } = useParams(); // Get GeoFence ID from route params
  const history = useHistory();
  const [geoFence, setGeoFence] = useState(null); // Store GeoFence data
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state
  const [map, setMap] = useState(null); // Leaflet map instance
  const [coordinates, setCoordinates] = useState(DEFAULT_COORDINATES); // Store track coordinates

  // Fetch GeoFence data
  useEffect(() => {
    fetchGeoFence();
  }, [id]);

  const fetchGeoFence = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axiosInstance.get(`/geofence/${id}`, {
        headers: {
          Authorization: token,
        },
      });

      if (response.status === 200 && response.data.success) {
        const geoFenceData = response.data.data;
        setGeoFence(geoFenceData);

        // Fetch track coordinates
        if (geoFenceData.track && geoFenceData.track.address) {
          fetchCoordinates(geoFenceData.track.address);
        } else {
          setError("Track address not available. Using default coordinates.");
        }
      } else {
        setError("GeoFence not found.");
      }
    } catch (err) {
      console.error("Error fetching GeoFence:", err);
      setError("Failed to fetch GeoFence. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const fetchCoordinates = async (address) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`
      );
      const data = await response.json();
      if (data.length > 0) {
        const { lat, lon } = data[0];
        setCoordinates({ lat: parseFloat(lat), lon: parseFloat(lon) });
      } else {
        setError("Could not find location for the address. Using default coordinates.");
      }
    } catch (err) {
      console.error("Error fetching coordinates:", err);
      setError("Failed to fetch coordinates for the address. Using default coordinates.");
    }
  };

  // Render polygons on the map
  useEffect(() => {
    if (coordinates && geoFence && geoFence.cameras && document.getElementById("map")) {
      if (map) {
        map.remove(); // Clear existing map
      }

      const mapInstance = L.map("map", {
        center: [coordinates.lat, coordinates.lon],
        zoom: 15,
      });

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(mapInstance);

      // Add polygons for camera zones
      geoFence.cameras.forEach((zoneGroup) => {
        zoneGroup.forEach((polygon) => {
          if (Array.isArray(polygon)) {
            const latLngs = polygon.map(([lng, lat]) => [lat, lng]); // Convert to [lat, lng]
            L.polygon(latLngs, {
              color: "blue",
              fillColor: "blue",
              fillOpacity: 0.4,
            }).addTo(mapInstance);
          }
        });
      });

      setMap(mapInstance);
    }
  }, [coordinates, geoFence]);

  const handleBack = () => {
    if (geoFence?.track?.trackId) {
      history.push(`/geo-fences?trackId=${geoFence.track.trackId}`); // Navigate to geo-fences with trackId
    } else {
      history.push("/geo-fences"); // Default geo-fences page
    }
  };

  if (loading) {
    return (
      <Container>
        <Row
          className="text-center w-100"
          style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}
        >
          <Spinner animation="border" />
        </Row>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Row
          className="text-center w-100"
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h4>{error}</h4>
        </Row>
      </Container>
    );
  }

  return (
    <ContentWrapper>
      <Container fluid>
        <Row className="mb-3">
          <Col xs={12}>
            <h2>{geoFence.geoMapName || "Unnamed Geo Map"}</h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div id="map" style={{ height: "700px", width: "100%" }}></div>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} className="text-right">
            <button className="btn btn-primary sv_btn" onClick={handleBack}>
              Back to GeoFences
            </button>
          </Col>
        </Row>
      </Container>
      <ThinFooter />
    </ContentWrapper>
  );
};

export default SingleGeoFences;
